import React from 'react';
import './Service.css';
import ServiceBG from "../../../Assets/splashfinacc.svg";
import ServiceItem from "../SubServiceItem/ServiceItem";
import ServiceHighlights from "../SeviceHighlights/ServiceHighlights";

const Service = props => {
    let serviceData = props.data;
    let subItemsMarkup = null;
    let highlightsMarkup = null;
    let imgStyle = null;
    if(serviceData.title === "Due Diligence"){
        console.log("due dill");
        imgStyle = {"width":"60% !important"};
        console.log(imgStyle);
    }
    if(serviceData.subItems!=null){
        subItemsMarkup = serviceData.subItems.map((item, index)=>{
            return (
                <ServiceItem data={item} key={""+index}/>
            );
        });
    }
    if(serviceData.highlights!=null){
        highlightsMarkup = <ServiceHighlights data={serviceData.highlights}/>;
    }

    return (
        <div className="services">
            <div className="service-splash">
                <div className="splash-desc">
                    <h2>{serviceData.title}</h2>
                    {serviceData.titleDesc.map((item, index)=>{
                        return (
                            <p key={''+index}>
                                {/*<i className="fas fa-hand-point-right" />*/}
                                {item}
                            </p>
                        );
                    })}
                   </div>
                <div className="splash-img">
                    <img src={serviceData.banner} alt="splash-bg" style={imgStyle}/>
                </div>
            </div>
            {subItemsMarkup}
            {highlightsMarkup}

        </div>
    );
};

export default Service;


// WEBPACK FOOTER //
// ./src/Components/ServicesPage/Service/Service.js